import { httpRequest } from '@calendly/http-tools'

import { ORGANIZATION_MEMBERSHIP_ROLES } from 'constants/organization_roles'

import { ORG_ADMINS_PAGE_SIZE } from './constants'

export const postDomainControl = (verificationMethod, domain) => httpRequest({
  url: '/api/organization/domain_controls',
  method: 'POST',
  data: {
    domain,
    verification_method: verificationMethod,
  }
})

export const getDomainControlsList = () => httpRequest({
  url: '/api/organization/domain_controls',
  method: 'GET',
})

export const destroyDomainControl = (domainControl) => httpRequest({
  url: `/api/organization/domain_controls/${domainControl.uuid}`,
  method: 'DELETE'
})

export const putVerifyDomainControl = (domainControl) => httpRequest({
  url: `/api/organization/domain_controls/${domainControl.uuid}/verify`,
  method: 'PUT'
})

export const getDomainSummary = (domainControl) => httpRequest({
  url: `/api/organization/domain_controls/${domainControl.uuid}/summary`,
  method: 'GET',
})

export const patchDomainControlRequest = (uuid, data) => httpRequest({
  url: `/api/organization/domain_controls/${uuid}`,
  method: 'PATCH',
  data
})

export const getDomainControlSetting = () => httpRequest({
  url: '/api/organization/domain_control_setting',
  method: 'GET'
})

export const patchDomainControlSetting = (accessOwnerType, accessOwnerValue) => httpRequest({
  url: '/api/organization/domain_control_setting',
  method: 'PATCH',
  data: {
    access_owner_type: accessOwnerType,
    access_owner_value: accessOwnerValue
  }
})

export const getOrganizationMemberships = () => httpRequest({
  url: '/api/organization/memberships',
  method: 'GET',
  params: {
    role: [ORGANIZATION_MEMBERSHIP_ROLES.ADMIN, ORGANIZATION_MEMBERSHIP_ROLES.OWNER],
    sort_field: 'human_role',
    sort_order: 'desc',
    page_size: ORG_ADMINS_PAGE_SIZE
  }
})

export const postExport = (domainControl) => httpRequest({
  url: '/api/organization/domain_controls/export',
  method: 'POST',
  data: {
    domain_control_uuid: domainControl.uuid
  }
})
